import { Flex, Spinner, Text, VStack } from "@chakra-ui/react";
import React from "react";

interface Props {
  text?: string;
}
export const LoadingScreen: React.FC<Props> = ({ text }) => {
  return (
    <Flex
      height="100%"
      width="100%"
      position="absolute"
      top={0}
      left={0}
      backgroundColor="white"
      justifyContent="center"
      alignItems="center"
    >
      <VStack gap={4}>
        <Spinner borderWidth="3px" size="xl" color="primary.500" />
        <Text textAlign="center" maxWidth="270px" fontSize="sm">
          {text}
        </Text>
      </VStack>
    </Flex>
  );
};
